import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const s = {
  page: { minHeight:'100vh', background:'var(--paper)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 },
  card: { background:'var(--card)', border:'1px solid var(--line-card)', borderRadius:0, width:'100%', maxWidth:420, overflow:'hidden' },
  header: { background:'var(--ink)', padding:'28px 32px' },
  brand: { fontFamily:'var(--font-display)', color:'var(--paper)', fontSize:20 },
  body: { padding:'32px' },
  title: { fontFamily:'var(--font-display)', fontSize:20, fontWeight:700, marginBottom:6, color:'var(--ink)' },
  sub: { color:'var(--muted)', fontSize:13, marginBottom:24, lineHeight:1.6 },
  label: { display:'block', fontSize:11, fontFamily:'var(--font-mono)', letterSpacing:'1px', marginBottom:6, textTransform:'uppercase', color:'var(--muted-2)' },
  input: { width:'100%', padding:'11px 14px', border:'1px solid var(--line)', borderRadius:0, fontSize:14, outline:'none', fontFamily:'var(--font-body)', background:'var(--card)' },
  btn: { width:'100%', background:'var(--ink)', color:'var(--paper)', border:'none', padding:'13px', fontSize:15, fontWeight:600, borderRadius:0, cursor:'pointer', marginTop:16 },
  success: { background:'#f0fdf4', border:'1px solid #86efac', color:'#15803d', padding:'14px', borderRadius:0, fontSize:14, lineHeight:1.5, marginBottom:16 },
  link: { display:'block', textAlign:'center', marginTop:16, fontSize:13, color:'var(--muted)' },
  linkText: { color:'var(--ink)', fontWeight:600 }
};

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch {}
    setLoading(false);
  };

  return (
    <div style={s.page}>
      <div style={s.card} className="fade-in">
        <div style={s.header}><div style={s.brand}>BioMedArticles</div></div>
        <div style={s.body}>
          <h2 style={s.title}>Reset password</h2>
          <p style={s.sub}>Enter your email and we'll send a reset link.</p>
          {sent ? (
            <div style={s.success}>✓ If that email exists, a reset link was sent. Check your inbox (and spam folder).</div>
          ) : (
            <form onSubmit={handleSubmit}>
              <label style={s.label}>Email</label>
              <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@institution.edu" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
              <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send reset link →'}
              </button>
            </form>
          )}
          <Link to="/login" style={s.link}><span style={s.linkText}>← Back to sign in</span></Link>
        </div>
      </div>
    </div>
  );
}
